import React from 'react';

const PublicConfigContext = React.createContext({});
export default PublicConfigContext;
